export const Modes = {
    APP: 'app',
    DESKTOP: 'desktop',
    MONITOR: 'monitor',
    BROWSER: 'browser',
};

export const getMode = async () => {
    if (window?.tactix?.mode === undefined || window?.tactix?.mode === null) {
        // fallback: if ReactNativeWebView is present, we are running inside the app
        if (window?.ReactNativeWebView) {
            return Promise.resolve(Modes.APP);
        }

        return Promise.resolve(Modes.BROWSER);
    }

    const ret = window?.tactix?.mode();

    // keep bc until all monitors have desktop app version >= 1.2.0
    if (typeof ret === 'string') {
        return Promise.resolve(ret);
    }

    return ret;
};
